import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-jornada-sessao-dialog',
  templateUrl: 'dialog.component.html',
})
export class JourneySessionDialogComponent implements OnInit {

  loading: boolean;
  sessions: string;
  session: string;

  constructor(
    public dialogRef: MatDialogRef<JourneySessionDialogComponent>,
    public dataService: DataService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.getSessions();
  }

  getSessions() {
    this.dataService.jornadasSessao().subscribe((response: any) => {
      this.loading = false;
      this.sessions = response.data;
      if (this.sessions.length == 0) {
        this.onNoClick();
      }
    });
  }

  selectSession(session: any) {
    this.dialogRef.close(session);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
